/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NonceAttestationData
 */
export interface NonceAttestationData {
    /**
     * 
     * @type {string}
     * @memberof NonceAttestationData
     */
    challenge?: string;
}

/**
 * Check if a given object implements the NonceAttestationData interface.
 */
export function instanceOfNonceAttestationData(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function NonceAttestationDataFromJSON(json: any): NonceAttestationData {
    return NonceAttestationDataFromJSONTyped(json, false);
}

export function NonceAttestationDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): NonceAttestationData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'challenge': !exists(json, 'challenge') ? undefined : json['challenge'],
    };
}

export function NonceAttestationDataToJSON(value?: NonceAttestationData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'challenge': value.challenge,
    };
}

